/** Mock 数据；是否在 Api 中启用由 StoreOrderApi 内 mockStoreOrder + REACT_APP_USE_MOCK 控制。 */
import type {
  CreateStoreOrderResult,
  PreparePayParamBody,
  PreparePayResult,
  QueryPayStatusParamBody,
  QueryPayStatusResult,
} from "./StoreOrderType";

let mockOrderSeq = 1;
const mockPayPoll = new Map<string, number>();

export async function mockCreateOrder(p: {
  spaceId: string;
  spaceProductId: string;
  serviceTier: string;
}): Promise<CreateStoreOrderResult> {
  const id = `Omock${String(mockOrderSeq++).padStart(10, "0")}`;
  let price = 99;
  if (p.serviceTier === "m3") price = 268;
  if (p.serviceTier === "m6") price = 488;
  if (p.serviceTier === "y1") price = 888;
  return {
    createResult: 0,
    failMessage: null,
    orderId: id,
    orderPrice: price,
  };
}

export function mockPreparePay(p: PreparePayParamBody): PreparePayResult {
  mockPayPoll.set(p.orderId, 0);
  const scene = p.payScene ?? "web_page";
  const aggregatorCode = "lakala";
  if (scene === "web_page") {
    const q = encodeURIComponent(`${p.orderId}|mock`);
    return {
      aggregatorCode,
      payScene: scene,
      orderId: p.orderId,
      payAmountYuan: 99,
      checkoutCredentialType: "redirectUrl",
      redirectUrl: `https://example.com/mock-cashier?order=${q}`,
      productTypeLabel: "策略",
      serviceTierLabel: "1个月",
    };
  }
  return {
    aggregatorCode,
    payScene: scene,
    orderId: p.orderId,
    payAmountYuan: 99,
    checkoutCredentialType: "wechatMiniprogram",
    wechatMiniprogramPayParams: {
      appId: "wx_mock_app",
      timeStamp: String(Math.floor(Date.now() / 1000)),
      nonceStr: "mock_nonce",
      package: `prepay_id=mock_${p.orderId}`,
      signType: "RSA",
      paySign: "mock_sign",
    },
    productTypeLabel: "策略",
    serviceTierLabel: "1个月",
  };
}

export function mockQueryPayStatus(p: QueryPayStatusParamBody): QueryPayStatusResult {
  const n = (mockPayPoll.get(p.orderId) ?? 0) + 1;
  mockPayPoll.set(p.orderId, n);
  if (n >= 2) {
    const t = new Date();
    const pad = (x: number) => String(x).padStart(2, "0");
    return {
      paid: true,
      payTime: `${t.getFullYear()}-${pad(t.getMonth() + 1)}-${pad(t.getDate())} ${pad(t.getHours())}:${pad(t.getMinutes())}:${pad(t.getSeconds())}`,
    };
  }
  return { paid: false, payTime: "" };
}
